import { render, staticRenderFns } from "./StarEffectEdit.vue?vue&type=template&id=e1956258&"
import script from "./StarEffectEdit.vue?vue&type=script&lang=js&"
export * from "./StarEffectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports